<template>
  <v-content>
    <site-header></site-header>
    <router-view />
    <site-footer></site-footer>
  </v-content>
</template>

<script>
import SiteHeader from './includes/Header'
import SiteFooter from './includes/Footer'
export default {
  components: {
    SiteHeader,
    SiteFooter
  }
}
</script>